module.exports = __webpack_public_path__ + "static/media/kitchen-3.a23a4ee2.jpg";